module.exports = __webpack_public_path__ + "img/pulsar.586f68de.gif";